/** PURE_IMPORTS_START .._.._Observable,.._.._operator_bufferCount PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { bufferCount } from '../../operator/bufferCount';
Observable.prototype.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/bufferCount.js
// module id = 644
// module chunks = 0